import React from "react";
import styles from "../../style/skeleton.module.css";

const Skeleton = ({ className = "", as: Tag = "span", ...rest }) => (
  <Tag
    className={`${styles.skeleton}${className ? ` ${className}` : ""}`}
    aria-hidden="true"
    {...rest}
  />
);

export default Skeleton;
